<template>
  <div class="firm_container">
    <div class="firm_Main_body">
      <!-- 头部导航栏 -->
      <div class="Navigation_con1">
        <NavFirm :navNum="1" @handleWarn="handleWarn"></NavFirm>
      </div>
      <div class="firm-nav-table">
        <div class="nav-left">
          <div class="menu-box">
            <div class="menu-title" @click="goBack">
              <img
                class="title-img"
                src="@/assets/imgs/back-da@3x.svg"
                alt=""
              />
              <span class="title-text">返回首页</span>
            </div>
            <div
              v-for="(item, index) in menuList"
              :key="item.id"
              v-show="item.id !== 5 || showInterviewMenu"
              @click="routerChange(index, item)"
              :class="
                selIndex != index ? 'menu-box-item-yes' : 'menu-box-item-no'
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div
            style="
              width: 1200px;
              min-height: calc(100vh - 60px);
              margin: 0 auto;
              padding-top: 20px;
              box-sizing: border-box;
            "
          >
            <router-view></router-view>
          </div>
          <!-- 账号注销提示弹窗 -->
          <SignOut
            :dialogSignOut="dialogSignOut"
            @handleClose="handleClose"
            @handleUnderstand="handleUnderstand"
          >
          </SignOut>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 账号注销提示弹窗
import SignOut from "../../personage/home/components/Popup/SignOut.vue";
import NavFirm from "../../../components/NavFirm.vue";
export default {
  props: {},
  components: {
    NavFirm,
    SignOut,
  },
  data() {
    return {
      scroll: "",
      scrollType: "1",
      searchType: "",
      dialogSignOut: false,
      // 原始菜单（带权限）
      originMenuList: [
        {
          name: "职位管理",
          url: "/Firm/recruitPosition",
          id: 1,
          val: ["company:position:manage"],
        },
        {
          name: "精英推荐",
          url: "/Firm/recruitElite",
          id: 2,
          val: ["company:elite:recommend"],
        },
        {
          name: "精英管理",
          url: "/Firm/recruitManager",
          id: 3,
          val: [
            "company:elite:communicate",
            "company:elite:manage",
            "company:elite:collect",
            "company:elite:inappropriate",
          ],
        },
        // 暂无企业沟通
        // {
        //   name: "沟通列表",
        //   url: "/Firm/recruitCommunicate",
        //   id: 4,
        //   val: "company:elite:communicate",
        // },
        {
          name: "招聘数据",
          url: "/Firm/recruitData",
          id: 6,
        },
      ],
      menuList: [], // 过滤后的最终菜单
      selIndex: 0,
      showInterviewMenu: false,
    };
  },
  watch: {
    scroll(newss) {
      this.scrollType = newss > 80 ? "2" : "1";
    },
  },
  created() {
    this.filterMenuByPermission();
    this.$bus &&
      this.$bus.$on("admin-permission-updated", this.filterMenuByPermission);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    this.$bus &&
      this.$bus.$off("admin-permission-updated", this.filterMenuByPermission);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // ======================
    // 权限过滤 + 自动跳转修复
    // ======================
    filterMenuByPermission() {
      const permissionCodesStr = localStorage.getItem("permissionCodes");
      const permissionArr = permissionCodesStr ? JSON.parse(permissionCodesStr) : [];

      // 1. 过滤菜单
      this.menuList = this.originMenuList.filter((item) => {
        if (!item.val) return true;
        const checkList = Array.isArray(item.val) ? item.val : [item.val];
        return checkList.some((p) => permissionArr.includes(p));
      });

      // 2. 🔥 核心修复：如果当前页面不在菜单里 → 自动跳转到第一个菜单
      this.$nextTick(() => {
        if (this.menuList.length === 0) return;

        const currentPath = this.$route.path;
        const isPageValid = this.menuList.some(m => m.url === currentPath);

        if (!isPageValid) {
          // 页面无效 → 跳转到第一个有权限的页面
          this.selIndex = 0;
          this.$router.replace(this.menuList[0].url);
        } else {
          // 页面有效 → 正确高亮
          this.selIndex = this.menuList.findIndex(m => m.url === currentPath);
        }
      });
    },

    // ======================
    // 菜单点击
    // ======================
    routerChange(index, item) {
      this.selIndex = index;
      this.$router.push(item.url);
    },

    // ======================
    // 原有方法
    // ======================
    refreshSelIndex() {},
    handleWarn() { this.dialogSignOut = true; },
    handleClose() { this.dialogSignOut = false; },
    handleUnderstand() { this.dialogSignOut = false; this.$router.push("/login"); },
    goBack() { this.$router.push({ path: "/FirmHomePage" }); },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/firmEachIndex.css";

.firm_container {
  .firm_Main_body {
    .firm-nav-table {
      display: flex;
      .nav-left {
        width: 200px;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        color: #333;
        background-color: #fff;

        .menu-box {
          .menu-title {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            background: rgba(97, 144, 232, 0.3);
            border-radius: 10px;
            font-size: 20px;
            color: #409eff ;
            margin: 10px 10px 20px;
            cursor: pointer;

            .title-img {
              margin: 2px 10px 0 0;
            }
            .title-text {
              font-size: 20px;
            }
          }

          .menu-box-item-yes {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            font-size: 16px;
            margin: 8px 10px;
            cursor: pointer;
            color: #333;
          }

          .menu-box-item-no {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #eeeeee;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            margin: 8px 10px;
            color: #409eff ;
          }
        }
      }
      .nav-right {
        flex: 1;
        background: rgba(97, 144, 232, 0.1);
        border-radius: 50px 0px 0px 50px;
      }
    }
  }
}
/deep/.el-input__inner {
  border: 1px solid #409eff  !important ;
}
</style>
